import { money, type Currency, type Money } from '@radish/primitives';

// The only place Money values are combined (invariant A4). Mixing currencies is a programming error and throws.

const sameCurrency = (a: Money, b: Money): Currency => {
  if (a.currency !== b.currency) throw new RangeError(`money: currency mismatch ${a.currency} vs ${b.currency}`);
  return a.currency;
};

export const zero = (currency: Currency): Money => money(0n, currency);
export const add = (a: Money, b: Money): Money => money(a.minor + b.minor, sameCurrency(a, b));
export const subtract = (a: Money, b: Money): Money => money(a.minor - b.minor, sameCurrency(a, b));
export const negate = (a: Money): Money => money(-a.minor, a.currency);
export const multiply = (a: Money, factor: bigint): Money => money(a.minor * factor, a.currency);
export const sum = (items: readonly Money[], currency: Currency): Money => items.reduce(add, zero(currency));
export const compare = (a: Money, b: Money): -1 | 0 | 1 => {
  sameCurrency(a, b);
  if (a.minor === b.minor) return 0;
  return a.minor < b.minor ? -1 : 1;
};
export const isZero = (a: Money): boolean => a.minor === 0n;
export const isNegative = (a: Money): boolean => a.minor < 0n;
